/*
 * Copyright (c) 2024. Bluemate B.V.
 */

import {useContext, useMemo} from 'react';

import {AccessKey} from '../../util/interfaces';

import {AppContext} from './appContext';

import {userHasRight} from '../../util/accessUtil';

export default function useRight(...accessKeys: Array<AccessKey>): Array<boolean> {
    const context = useContext(AppContext);
    return useMemo(() => {
        return accessKeys.map((key: AccessKey) => userHasRight(context.accountContext.account, key));
    }, [context.accountContext.account, accessKeys]);
}
